import React from 'react'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';

import "react-datepicker/dist/react-datepicker.css";
import { PortalComponent } from '../atoms/Portal';

const PortalDatePicker = ({
    contentRef,
    setShowDatePicker,
    validValue,
    value,
    dateSelected,
    maxDate,
    minDate,
    disabledDatesProps,
    position,
    onCloseDatePicker,
    ...rest
}) => {

    return (
        <>
            <div className='fixed w-full h-full left-0 top-0 z-[1000]' onClick={onCloseDatePicker}></div>
            <div id='dropdownContent' className='fixed py-2.5 will-change-transform border border-gray-200 w-full max-w-[278px] overflow-hidden top-0 z-[1001] bg-white flex flex-col md:justify-between md:w-[19rem] left-0'
                onClose={() => setShowDatePicker(false)}
                style={position}
            >
                <Calendar
                    showDoubleView={false}
                    className='calendar-custom'
                    value={validValue ? value : ''}
                    calendarType="gregory"
                    formatShortWeekday={(locale, date) => moment(date).format('dd').charAt(0)}
                    onChange={(props) => { dateSelected(props); setShowDatePicker(false) }}
                    maxDate={maxDate}
                    minDate={minDate}
                    prev2AriaLabel={'prev'}
                    prevLabel={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M497.137 511.996l210.743-210.746-90.508-90.509-301.255 301.255 301.255 301.256 90.508-90.509-210.743-210.747z "></path></svg>}
                    nextLabel={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M526.863 511.996l-210.745-210.746 90.509-90.509 301.256 301.255-301.256 301.256-90.509-90.509 210.745-210.747z "></path></svg>}
                    {...disabledDatesProps}
                    {...rest}
                />
            </div>
        </>
    )
}

export default PortalComponent(PortalDatePicker)

